import React, { Component, Fragment } from 'react'
import propTypes from 'prop-types'
import { Divider, Icon, Tooltip } from 'antd'

class ViewDownload extends Component {
  render() {
    const { view, download } = this.props
    return (
      <Fragment>
        <Tooltip title="View File">
          <a target="_blank" href={view}>
            <Icon type="eye" />
          </a>
        </Tooltip>
        <Divider type="vertical" />
        <Tooltip title="Download File">
          <a href={download}>
            <Icon type="download" />
          </a>
        </Tooltip>
      </Fragment>
    )
  }
}

ViewDownload.propTypes = {
  view: propTypes.string.isRequired,
  download: propTypes.string.isRequired,
}
ViewDownload.defaultProps = {
  view: '#/',
  download: '#/',
}

export default ViewDownload
